<template>
  <button :class="onMobile ? 'button-wrapper-mobile' : 'button-wrapper'" :style="setWrapperStyle()" @click="$emit('select')">
    <div class="card" :class="selected ? 'card-selected' : '' ">
      <div class="card-header">
        <img :src="image" alt="" @error="setBackupImage($event)">
      </div>

      <div class="info">
        <div class="card-info">
          <h3>{{ label }}</h3>
          <span class="description">
            {{ description }}
          </span>
        </div>

        <div class="infobox" v-if="infobox">
          <button 
            class="infobox-button-specs" 
            @mouseover="specsBtnMouseOver" 
            @mouseleave="specsBtnMouseLeave"
            @click.stop="enableAndHoldSpecs()"
          >
            <div class="infobox-question-mark" style="pointer-events: none;">?</div>
            <span class="infobox-button-specs-text">
              Meer info
            </span>
          </button>
        </div>
      </div>
    </div>
  </button>


  <Teleport to="body">
    <Transition name="fade">
      <div
        v-show="specsVisible"
        id="fullcover"
        @click="specsVisible = false"
      >              
        <div 
          :class="onMobile ? 'modalspecs modalspecs-size-mobile' : 'modalspecs modalspecs-size'"
          @click.stop=""
        >
            <button 
              class="modalclosebutton" 
              @mouseover="specsCloseBtnMouseOver" 
              @mouseleave="specsCloseBtnMouseLeave"
              @click="specsVisible = false"
            >
              <Transition name="closebtn">
                <div 
                  v-show="hasGlowingCloseBtn"
                  class="absolutepos glowingclose"
                />
              </Transition>
              <div>
                ×
              </div>
            </button>
          <!-- <div class="greyheader"> 
            {{ data.infobox.header }}
          </div> -->
          <div class="imagescroller">
            <img class="modalimage" :src="`/infoboximages/${infoboxes.find(info => info.id === infobox)?.urlEnding}`" alt="">
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: "OptionCard",

    props: {
      data: Object,
      selected: Boolean,
      hasAutomargin: {
        type: Boolean,
        default: true
      },
      hasWidthlimit: {
        type: Boolean,
        default: true
      },
      image: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      infobox: {
        type: String,
        default: '',
      }
    },

    data () {
      return {
        onMobile: false,
        specsVisible: false,
        hasGlowingInfoBtn: false,
        hasGlowingCloseBtn: false,
      }
    },

    computed: {
      ...mapGetters({
        infoboxes: 'getInfoboxes', 
        funderingTypes: 'getFunderingTypesPublic',
      }),
    },

    created() {
      let regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      this.onMobile = regex.test(navigator.userAgent)
    },

    methods: {
      setBackupImage(e) {
        // e.target.src = ""//`https://fakeimg.pl/400x400/?text=${this.label}&font=bebas`
      },
      setWrapperStyle() {
        return `${this.hasAutomargin ? '' : 'margin: 0px;'}${this.hasWidthlimit ? '' : 'max-width: none; width: 100%;'}`
      },
      specsBtnMouseOver() {
        this.hasGlowingInfoBtn = true;
      },
      specsBtnMouseLeave(){
        this.hasGlowingInfoBtn = false;
      },
      specsCloseBtnMouseOver() {
        this.hasGlowingCloseBtn = true;
      },
      specsCloseBtnMouseLeave(){
        this.hasGlowingCloseBtn = false;
      },
      enableAndHoldSpecs() {
        this.specsVisible = !this.specsVisible;
      }
    },
      
  }
</script>

<style lang="scss" scoped>

.card {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  border: 2px solid $c-border-1;
  border-radius: $radius-m;
  padding: 16px;
  transition: border-color 100ms ease;
  background-color: transparent;
  scroll-margin: 150px;
  transition: border 100ms;

  &:hover {
    border-color: $c-secondary;
    cursor: pointer;
  }

  &-selected {
    border: 4px solid $c-secondary;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    height: 180px;

    & img {
      min-height: 180px;
      max-height: 180px;
      width: 100%;
      object-fit: contain;
    }
  }

  &-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    & h3 {
      font-size: 19px;
      font-weight: 700;
      font-family: 'Oswald', sans-serif;
      text-transform: uppercase;
      text-align: left;
      margin: 0px;
    }
  }
}

.button-wrapper {
  border: none;
  display: flex;
  margin: auto;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
  max-width: 16.5rem;
}

.button-wrapper-mobile {
  border: none;
  display: flex;
  margin: auto;
  padding: 0px;
  background-color: transparent;
  min-height: 100%;
  width: 93vw;
}

.description {
  font-weight: 400;
  text-align: left;
  display: flex;
}


.infobox {
  display: flex;
  justify-content: flex-end;
  flex: 1;
  &-button-specs {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: row;
    // position: absolute;
    margin-top: 4px;
    height: 23px;
    right: 0;
    padding: 3px;
    border-radius: $radius-l;
    border-style: none;
    background-color: $c-secondary; // babc16
    color: white; //$c-secondary-text;

    &-text {
      font-size: 0.8rem;
      padding: 0px 8px;
      padding-right: 16px;
      font-family: 'Source Sans 3', sans-serif;
    }
  }

  &-question-mark {
    // padding: 5px 10px;
    padding: 0px 5px;
    border-radius: $radius-l;
    font-weight: bold;
    font-size: 0.7rem;    
    color: white;
    background-color: $c-primary;
  }
}

.info {
  display: flex;
  align-items: end;
}





#fullcover {
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
}
.modalspecs {
  position: fixed;
  z-index: 999;
  // top: 10%;
  left: 50%;
  // width: 30rem;
  // margin-left: -15rem;
  // height: 80vh;
  background-color: white;
  border-radius: $radius-s;
}
.modalspecs-size {
    top: 3%;
    width: 36rem;
    margin-left: -18rem;
    height: 94vh;
 }
.modalspecs-size-mobile {
    top: 10%;
    width: 98%;
    margin-left: -49%;
    height: 80vh;
 }

.modaltopcontainer {
  display: flex; text-align: start; height: 8vh
}
.modaltopcontainer h3 {
  margin: 1.5vh 1.5vh 1.5vh 3vh;
}
// .greyheader {
//   color: $c-secondary;
//   background-color: $c-primary; 
//   border-radius: 5px; 
//   margin: 0px 10px 10px 10px; 
//   font-size: x-large;
//   text-align: center; 
// }

.imagescroller {
  // max-height: calc(85% - 1px); // a trick to force a scroll area to appear despite fixed position
  max-height: calc(98%); // minus size of modaltopcontainer
  overflow-y: auto;
  border-radius: $radius-m;
}
.modalimage {
  width: 100%;
  height: auto;
}

.modalclosebutton {
  position: absolute;
  // margin-left: auto;
  top: 32px;
  right: 48px;
  height: 4vh;
  width: 4vh;
  background: transparent;
  color: white;
  border: 2px solid white;
  box-sizing: border-box;
  border-radius: 3vh;
  // padding: 0px 10px 0px 10px;
  font-size: 4vh;
  pointer-events: all;
  cursor: pointer;
  // force the × to stay centered despite resizing
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;

  &:hover {
    background-color: rgba(255, 255, 15, 0.75);
  }
}

</style>